{
  "字段显隐配置": "Field visibility",
  "字段": "Field",
  "打码": "Mask",
  "有条件进入": "Conditional access",
  "可进入": "Accessible",
  "不可进入": "Inaccessible",
  "待核对": "Needs review",
  "已认证": "Verified",
  "已认证 · 非会员": "Verified · Non-member",
  "已认证 · 会员": "Verified · Member",
  "列表": "List",
  "供应": "Supply",
  "需求": "Demand",
  "{{count}} 项待核对": "{{count}} cells need review",
  "已导入草稿，保存后生效": "Draft imported. Save to apply it.",
  "覆盖未保存的修改？": "Replace unsaved changes?",
  "导入记录将替换当前草稿。": "The imported record will replace the current draft.",
  "JSON 文件不能超过 1 MB": "JSON files must not exceed 1 MB",
  "无法读取 JSON 文件": "Unable to read the JSON file",
  "请导入版本 3 的完整供需字段显隐记录": "Import a complete version 3 field visibility record",
  "字段重复或场景配置不完整": "Duplicate fields or incomplete scenario settings",
  "已重新加载配置": "Configuration reloaded",
  "放弃未保存的修改？": "Discard unsaved changes?",
  "字段显隐配置已保存并生效": "Field visibility saved and applied",
  "保存并生效": "Save and apply",
  "供应标题": "Supply title",
  "需求标题": "Demand title",
  "发布企业名称": "Publisher company name",
  "企业所在国家 / 地区": "Company country / region",
  "企业认证标识": "Company verification badge",
  "信息简述": "Summary",
  "发布时间": "Published at",
  "发布企业所属行业": "Publisher company industry",
  "目标国家 / 地区": "Target countries / regions",
  "供需说明": "Listing description",
  "附件": "Attachments",
  "即时沟通权限": "Messaging access",
  "供需字段显隐表": "Supply and demand field visibility",
  "已登录 · 未认证": "Signed in · Unverified",
  "功能权限": "Feature permission",
  "发布方卖方 · {{state}}（已认证）": "Seller publisher · {{state}} (verified)",
  "发布方买方 · 已认证": "Buyer publisher · Verified",
  "{{name}}字段": "{{name}} fields",
  "{{name}}信息字段表": "{{name}} field matrix",
  "{{visible}} / {{total}} 个字段 · {{scenes}} / {{totalScenes}} 个场景": "{{visible}} / {{total}} fields · {{scenes}} / {{totalScenes}} scenarios",
  "打码：可看到有附件，不能下载。": "Masked: attachment presence is visible; downloads are disabled.",
  "筛选字段与场景": "Filter fields and scenarios",
  "查找字段": "Find field",
  "输入字段名称": "Enter field name",
  "卖方会员状态": "Seller membership",
  "会员和非会员": "Members and non-members",
  "只有会员": "Members only",
  "只有非会员": "Non-members only",
  "查看方登录 / 认证状态": "Viewer sign-in / verification",
  "全部状态": "All states",
  "页面": "Page",
  "列表和详情都有": "List and detail",
  "只有列表": "List only",
  "只有详情": "Detail only",
  "按维度筛选差异字段": "Filter fields by differences",
  "全部字段": "All fields",
  "卖方会员状态有差异": "Seller membership differs",
  "查看方登录 / 认证状态有差异": "Viewer sign-in / verification differs",
  "列表与详情有差异": "List and detail differ",
  "差异仅比较其他条件相同的当前显示列；需求表筛选卖方会员状态时，只显示已认证的卖方场景。": "Differences compare visible columns with other conditions unchanged. Filtering seller membership in demand shows verified seller scenarios only.",
  "没有符合条件的字段或场景，请调整筛选。": "No matching fields or scenarios. Adjust the filters.",
  "导出记录": "Export record",
  "导入记录": "Import record"
}
